import { InstantPushConfigState } from './InstantPushConfigState';
import { DateTimeUtil } from '../common/DateTimeUtil';
import * as InternalTypes from '../common/InternalTypes';

export class InstantPushState {
	private _triggeredDateTimes: number[] = [];
	private _instantPushConfigStates = new Map<string, InstantPushConfigState>();

	initFromJsonObject(instantPush: InternalTypes.InstantPushState) {
		this._triggeredDateTimes = instantPush.triggeredDateTimes;
		instantPush.configs.forEach((instantPushConfig) => {
			this._parseInstantPushConfigState(instantPushConfig);
		});
	}

	private _parseInstantPushConfigState(instantPushConfigState: InternalTypes.InstantPushConfigStates) {
		const instantPushConfigStateMap = new Map(Object.entries(instantPushConfigState));
		instantPushConfigStateMap.forEach((value) => {
			const instantPushConfig = new InstantPushConfigState();
			instantPushConfig.initFromJsonObject(value);
			const combinedKey = instantPushConfig.combinedKey;
			this._instantPushConfigStates.set(combinedKey, instantPushConfig);
		});
	}

	addNewTriggeredDateTime(triggeredDateTime: number) {
		this._triggeredDateTimes.push(triggeredDateTime);
	}

	removeExistingTriggeredDateTime(triggeredDateTime: number) {
		const index = this._triggeredDateTimes.indexOf(triggeredDateTime);
		if (index !== -1) {
			this._triggeredDateTimes.splice(index, 1);
		}
	}

	checkAndRemoveExpiredTriggeredDateTimes() {
		const triggeredDateTimes = this._triggeredDateTimes;
		const currentTime = Date.now();
		const expiredDateTimes = triggeredDateTimes.filter((triggeredDateTime) => {
			return currentTime - triggeredDateTime > DateTimeUtil.getMillisecondsFromHours(24);
		});
		expiredDateTimes.forEach((expiredDateTime) => {
			this.removeExistingTriggeredDateTime(expiredDateTime);
		});
	}

	addNewInstantPushConfig(combinedKey: string, instantPushConfig: InstantPushConfigState) {
		this._instantPushConfigStates.set(combinedKey, instantPushConfig);
	}

	removeExistingInstantPushConfig(combinedKey: string) {
		this._instantPushConfigStates.delete(combinedKey);
	}

	getTriggeredDateTimes() {
		return this._triggeredDateTimes;
	}

	getInstantPushConfigState(combinedKey: string): InstantPushConfigState | undefined {
		return this._instantPushConfigStates.get(combinedKey);
	}

	get instantPushJson(): InternalTypes.InstantPushState {
		const instantPushJsonObject: InternalTypes.InstantPushState = {
			triggeredDateTimes: [],
			configs: []
		};
		this._triggeredDateTimes.forEach((triggeredDateTime) => {
			instantPushJsonObject.triggeredDateTimes.push(triggeredDateTime);
		});
		this._instantPushConfigStates.forEach((item, key) => {
			instantPushJsonObject.configs.push({ [key]: item.instantPushConfigObject });
		});
		return instantPushJsonObject;
	}
}
